<template>
  <div>
    <div v-if="infos.length === 0" class="h5 mt-1">
      Bisher sind keine Termine vorhanden.
    </div>
    <div v-else>
      <div v-for="(info,idx) in getDates" :key="idx" class="mb-3">
        <span class="font-weight-bold">{{ info.oDateType.sName }}</span>:
        <span :class="info.class"> {{ info.sStatus }}  <i class="fas" :class="info.icon"></i></span>

      </div>
    </div>
  </div>
</template>

<script>

import DateService from '../services/DateService'

export default {
  name: 'DashboardDates',
  async mounted () {
    await this.init()
  },
  data () {
    return {
      infos: []
    }
  },
  methods: {
    async init () {
      var tmp = await DateService.getMyDates()
      this.infos = tmp.data.sort((a, b) => {
        return (a.lStatus > b.lStatus) ? -1 : (a.lStatus == b.lStatus) ? 0 : 1
      })
    }
  },
  computed: {
    getLocation () {
      return this.$store.getters.getLocation
    },
    getDates () {
      var parsendInfos = []
      this.infos.forEach(function (item) {
        switch (item.lStatus) {
          case 0:
            item.class = 'text-muted'
            item.icon = 'fa-check-circle'
            break
          case 1:
            item.class = 'text-success'
            item.icon = 'fa-check'
            break
          case 2:
            item.class = 'text-warning font-weight-bold'
            item.icon = 'fa-exclamation'
            break
          case 3:
            item.class = 'text-danger font-weight-bold'
            item.icon = 'fa-exclamation-triangle'
            break
        }
        parsendInfos.push(item)
      })
      return parsendInfos
    }
  },
  watch: {
    'getLocation' () {
      this.init()
    }
  }
}
</script>

<style scoped>
.cut-text {
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.5rem;
  max-height: 4.5rem;
}
</style>
